import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReviewsSection() {
  const { str } = useLang();
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios.get(`${API}/reviews`).then((r) => setReviews(r.data.reviews)).catch(() => {});
  }, []);

  if (reviews.length === 0) return null;

  return (
    <section id="reviews" data-testid="reviews-section" className="bg-[#0A0A0A] px-6 sm:px-10 lg:px-16 py-24 lg:py-32">
      <p className="font-ticker text-[11px] tracking-[0.3em] uppercase text-[#25D366] mb-6">{str.reviewsTag}</p>
      <h2 className="font-display font-black uppercase leading-[0.95] tracking-tight text-4xl sm:text-5xl lg:text-6xl mb-14">
        <span className="text-[#FDFDFD]">{str.reviewsH1}</span>
        <br />
        <span className="text-transparent [-webkit-text-stroke:1.5px_#25D366]">{str.reviewsH2}</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6" data-testid="reviews-grid">
        {reviews.map((r, i) => (
          <motion.article
            key={r.id || i}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
            data-testid={`review-card-${i}`}
            className="relative border border-white/10 bg-[#0F0F0F] p-7 flex flex-col gap-5 hover:border-[#25D366]/40 transition-colors duration-300"
          >
            <Quote size={22} className="text-[#25D366]/50" />
            <p className="text-sm text-white/70 leading-relaxed flex-1">{r.text}</p>
            <div>
              <div className="flex gap-1 mb-3" aria-label={`${r.rating} stars`}>
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={13} className={s < r.rating ? "fill-[#25D366] text-[#25D366]" : "text-white/15"} />
                ))}
              </div>
              <p className="font-ticker text-xs font-semibold tracking-[0.1em] uppercase text-[#FDFDFD]">{r.name}</p>
              {r.company && <p className="font-ticker text-[10px] tracking-[0.15em] uppercase text-white/35 mt-1">{r.company}</p>}
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
